import { metricColors } from "../../../components/custom/analytics/palettes";
import { type MetricConfig } from "../../merchandising/utils/metrics";

const IMPRESSIONS_AXIS = 2;
const CLICK_AXIS = 3;
const UNITS_AXIS = 4;
const BID_AXIS = 5;
const SALES_AXIS = 6;
const PERCENT_AXIS = 7;
const ROI_AXIS = 8;
const RATE_AXIS = 15;

export const metrics: MetricConfig[] = [
  {
    id: "dsp_total_sales",
    serverId: "total_sales",
    defaultCompare: "percent",
    color: metricColors.sales[0],
    accessor: (d) => d?.total_sales,
    prev_accessor: (d) => d?.total_sales_prev,
    percent_accessor: (d) => d?.total_sales_percent,
    delta_accessor: (d) => d?.total_sales_delta,
    format: "currency",
    decimalPlaces: 2,
    axis: SALES_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_sales_percent",
    color: metricColors.sales[0],
    accessor: (d) => d?.total_sales_percent,
    format: "percent",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_sales_delta",
    color: metricColors.sales[0],
    accessor: (d) => d?.total_sales_delta,
    format: "currency",
    incremental: true,
    axis: SALES_AXIS,
  },
  {
    id: "dsp_sales",
    serverId: "sales",
    defaultCompare: "percent",
    color: metricColors.sales[4],
    accessor: (d) => d?.sales,
    prev_accessor: (d) => d?.sales_prev,
    percent_accessor: (d) => d?.sales_percent,
    delta_accessor: (d) => d?.sales_delta,
    format: "currency",
    decimalPlaces: 2,
    axis: SALES_AXIS,
    grouping: "advertising",
  },
  {
    id: "dsp_sales_percent",
    color: metricColors.sales[4],
    accessor: (d) => d?.sales_percent,
    format: "percent",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_sales_delta",
    color: metricColors.sales[4],
    accessor: (d) => d?.sales_delta,
    format: "currency",
    incremental: true,
    axis: SALES_AXIS,
  },

  {
    id: "dsp_impressions",
    serverId: "impressions",
    defaultCompare: "percent",
    color: metricColors.metric1[3],
    accessor: (d) => d?.impressions ?? 0,
    prev_accessor: (d) => d?.impressions_prev ?? 0,
    percent_accessor: (d) => d?.impressions_percent ?? null,
    delta_accessor: (d) => (d?.impressions ?? 0) - (d?.impressions_prev ?? 0),
    format: "number",
    chartType: "column",
    axis: IMPRESSIONS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_impressions_percent",
    color: metricColors.metric1[3],
    accessor: (d) => d?.impressions_percent,
    format: "percent",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_clicks",
    serverId: "clicks",
    defaultCompare: "percent",
    color: metricColors.metric1[0],
    accessor: (d) => d?.clicks ?? 0,
    prev_accessor: (d) => d?.clicks_prev ?? 0,
    percent_accessor: (d) => d?.clicks_percent ?? null,
    delta_accessor: (d) => (d?.clicks ?? 0) - (d?.clicks_prev ?? 0),
    chartType: "column",
    format: "number",
    axis: CLICK_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_clicks_percent",
    color: metricColors.metric1[0],
    accessor: (d) => d?.clicks_percent,
    format: "percent",
    axis: PERCENT_AXIS,
    incremental: true,
  },
  {
    id: "dsp_cost",
    serverId: "total_cost",
    defaultCompare: "percent",
    color: metricColors.cost[0],
    accessor: (d) => d?.total_cost,
    prev_accessor: (d) => d?.total_cost_prev,
    percent_accessor: (d) => d?.total_cost_percent,
    delta_accessor: (d) => d?.total_cost_delta ?? (d?.total_cost ?? 0) - (d?.total_cost_prev ?? 0),
    format: "currency",
    decimalPlaces: 2,
    axis: SALES_AXIS,
    grouping: "advertising",
  },
  {
    id: "dsp_cost_percent",
    color: metricColors.cost[0],
    accessor: (d) => d?.total_cost_percent,
    format: "percent",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_purchases",
    serverId: "total_purchases",
    defaultCompare: "percent",
    color: metricColors.metric4[4],
    accessor: (d) => d?.total_purchases ?? 0,
    prev_accessor: (d) => d?.total_purchases_prev ?? 0,
    percent_accessor: (d) => d?.total_purchases_percent ?? null,
    delta_accessor: (d) => (d?.total_purchases ?? 0) - (d?.total_purchases_prev ?? 0),
    chartType: "column",
    format: "number",
    axis: UNITS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_purchases_percent",
    color: metricColors.metric4[4],
    accessor: (d) => d?.total_purchases_percent,
    format: "percent",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_units",
    serverId: "units_sold",
    defaultCompare: "percent",
    color: metricColors.units[0],
    accessor: (d) => d?.units_sold,
    prev_accessor: (d) => d?.units_sold_prev,
    percent_accessor: (d) => d?.units_sold_percent ?? null,
    delta_accessor: (d) => d?.units_sold_delta ?? (d?.units_sold ?? 0) - (d?.units_sold_prev ?? 0),
    format: "number",
    axis: UNITS_AXIS,
    chartType: "column",
    grouping: "merchandising",
  },
  {
    id: "dsp_units_percent",
    color: metricColors.units[0],
    accessor: (d) => d?.units_sold_percent,
    format: "percent",
    axis: PERCENT_AXIS,
    incremental: true,
  },
  {
    id: "dsp_units_delta",
    color: metricColors.units[0],
    accessor: (d) => d?.units_sold_delta,
    format: "number",
    axis: PERCENT_AXIS,
    incremental: true,
  },

  {
    id: "dsp_total_units",
    serverId: "total_units_sold",
    defaultCompare: "percent",
    color: metricColors.units[0],
    accessor: (d) => d?.total_units_sold,
    prev_accessor: (d) => d?.total_units_sold_prev,
    percent_accessor: (d) => d?.total_units_sold_percent ?? null,
    delta_accessor: (d) => d?.total_units_sold_delta ?? (d?.total_units_sold ?? 0) - (d?.total_units_sold_prev ?? 0),
    format: "number",
    axis: UNITS_AXIS,
    chartType: "column",
    grouping: "merchandising",
  },
  {
    id: "dsp_total_units_percent",
    color: metricColors.units[0],
    accessor: (d) => d?.total_units_sold_percent,
    format: "percent",
    axis: PERCENT_AXIS,
    incremental: true,
  },
  {
    id: "dsp_total_units_delta",
    color: metricColors.units[0],
    accessor: (d) => d?.total_units_sold_delta,
    format: "number",
    axis: PERCENT_AXIS,
    incremental: true,
  },
  {
    id: "dsp_ctr",
    serverId: "click_thru_rate",
    defaultCompare: "delta",
    color: metricColors.metric3[4],
    accessor: (d) => d?.click_thru_rate,
    prev_accessor: (d) => (d?.click_thru_rate_prev ? d?.click_thru_rate_prev : 0),
    percent_accessor: (d) => d?.click_thru_rate_percent ?? null,
    delta_accessor: (d) => d?.click_thru_rate_delta ?? (d?.click_thru_rate ?? 0) - (d?.click_thru_rate_prev ?? 0),
    format: "percent",
    chartType: "line",
    axis: RATE_AXIS,
    decimalPlaces: 2,
    grouping: "advertising",
  },
  {
    id: "dsp_ctr_delta",
    color: metricColors.metric3[4],
    accessor: (d) => d?.click_thru_rate_delta,
    format: "percent",
    chartType: "line",
    incremental: true,
    axis: PERCENT_AXIS,
    decimalPlaces: 2,
  },
  {
    id: "dsp_total_acos",
    serverId: "tacos",
    defaultCompare: "delta",
    color: metricColors.acos[1],
    accessor: (d) => d?.tacos ?? 0,
    prev_accessor: (d) => d?.tacos_prev ?? 0,
    percent_accessor: (d) => d?.tacos_percent ?? null,
    delta_accessor: (d) => d?.tacos_delta ?? (d?.tacos ?? 0) - (d?.tacos_prev ?? 0),
    format: "percent",
    chartType: "line",
    axis: PERCENT_AXIS,
    lower: true,
    compareHighlight: "negativeIsGood",
    grouping: "merchandising",
  },
  {
    id: "dsp_total_acos_delta",
    color: metricColors.acos[1],
    accessor: (d) => d?.tacos_delta,
    format: "percent",
    decimalPlaces: 1,
    chartType: "line",
    axis: PERCENT_AXIS,
    incremental: true,
    lower: true,
  },
  {
    id: "cost_per_detail_page_view",
    color: metricColors.acos[1],
    accessor: (d) => d?.cost_per_detail_page_view,
    format: "currency",
    decimalPlaces: 2,
    chartType: "line",
    lower: true,
    compareHighlight: "negativeIsGood",
  },

  {
    id: "dsp_total_roas",
    serverId: "troas",
    defaultCompare: "delta",
    color: metricColors.roms[3],
    accessor: (d) => d?.troas ?? 0,
    prev_accessor: (d) => d?.troas_prev ?? 0,
    percent_accessor: (d) => {
      const prev = d?.troas_prev ?? 0;
      if (!prev) return null;
      const current = d?.troas ?? 0;
      return (current - prev) / prev;
    },
    delta_accessor: (d) => d?.troas_delta ?? (d?.troas ?? 0) - (d?.troas_prev ?? 0),
    format: "number",
    decimalPlaces: 1,
    chartType: "line",
    axis: ROI_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_roas_delta",
    color: metricColors.roms[3],
    accessor: (d) => d?.troas_delta,
    format: "number",
    decimalPlaces: 1,
    chartType: "line",
    axis: ROI_AXIS,
    incremental: true,
  },
  {
    id: "dsp_total_detail_page_views",
    serverId: "total_detail_page_view",
    defaultCompare: "percent",
    color: metricColors.metric2[0],
    accessor: (d) => d?.total_detail_page_views ?? d?.total_detail_page_view ?? d?.dsp_total_detail_page_views,
    prev_accessor: (d) => d?.total_detail_page_views_prev ?? d?.total_detail_page_view_prev,
    percent_accessor: (d) => d?.total_detail_page_views_percent ?? d?.total_detail_page_view_percent ?? null,
    delta_accessor: (d) =>
      (d?.total_detail_page_views ?? d?.total_detail_page_view ?? d?.dsp_total_detail_page_views ?? 0) -
      (d?.total_detail_page_views_prev ?? d?.total_detail_page_view_prev ?? 0),
    format: "number",
    axis: IMPRESSIONS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_detail_page_views_percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.total_detail_page_views_percent ?? d?.total_detail_page_view_percent,
    format: "percent",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_detail_page_view_rate",
    serverId: "total_detail_page_view_rate",
    defaultCompare: "delta",
    color: metricColors.metric1[0],
    accessor: (d) => (d?.total_detail_page_view_rate ? d?.total_detail_page_view_rate : 0),
    prev_accessor: (d) => d?.total_detail_page_view_rate_prev ?? null,
    percent_accessor: (d) => d?.total_detail_page_view_rate_percent ?? null,
    delta_accessor: (d) => d?.total_detail_page_view_rate_delta ?? null,
    format: "percent",
    chartType: "line",
    axis: PERCENT_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_detail_page_view_rate_delta",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_detail_page_view_rate_delta,
    format: "percent",
    chartType: "line",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_add_to_cart",
    serverId: "total_add_to_cart",
    defaultCompare: "percent",
    color: metricColors.metric2[0],
    accessor: (d) => d?.total_add_to_cart ?? d?.dsp_total_add_to_cart,
    prev_accessor: (d) => d?.total_add_to_cart_prev,
    percent_accessor: (d) => d?.total_add_to_cart_percent ?? null,
    delta_accessor: (d) => (d?.total_add_to_cart ?? d?.dsp_total_add_to_cart ?? 0) - (d?.total_add_to_cart_prev ?? 0),
    format: "number",
    axis: IMPRESSIONS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_add_to_cart_percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.total_add_to_cart_percent,
    format: "percent",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_add_to_cart_rate",
    color: metricColors.metric1[0],
    accessor: (d) => (d?.total_add_to_cart_rate ? d?.total_add_to_cart_rate : 0),
    format: "percent",
    chartType: "line",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_add_to_cart_rate_delta",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_add_to_cart_rate_delta,
    format: "percent",
    chartType: "line",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_new_to_brand_detail_page_views",
    serverId: "new_to_brand_detail_page_views",
    defaultCompare: "percent",
    color: metricColors.metric2[0],
    accessor: (d) => d?.new_to_brand_detail_page_views ?? d?.new_to_brand_detail_page_view,
    prev_accessor: (d) => d?.new_to_brand_detail_page_views_prev ?? d?.new_to_brand_detail_page_view_prev,
    percent_accessor: (d) =>
      d?.new_to_brand_detail_page_views_percent ?? d?.new_to_brand_detail_page_view_percent ?? null,
    delta_accessor: (d) =>
      (d?.new_to_brand_detail_page_views ?? d?.new_to_brand_detail_page_view ?? 0) -
      (d?.new_to_brand_detail_page_views_prev ?? d?.new_to_brand_detail_page_view_prev ?? 0),
    format: "number",
    axis: IMPRESSIONS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_new_to_brand_detail_page_views_percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.new_to_brand_detail_page_views_percent ?? d?.new_to_brand_detail_page_view_percent,
    format: "percent",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_new_to_brand_detail_page_views_rate",
    serverId: "new_to_brand_detail_page_views_rate",
    defaultCompare: "delta",
    color: metricColors.metric1[0],
    accessor: (d) => (d?.new_to_brand_detail_page_views_rate ? d?.new_to_brand_detail_page_views_rate : 0),
    prev_accessor: (d) => d?.new_to_brand_detail_page_views_rate_prev ?? null,
    percent_accessor: (d) => d?.new_to_brand_detail_page_views_rate_percent ?? null,
    delta_accessor: (d) => d?.new_to_brand_detail_page_views_rate_delta ?? null,
    format: "percent",
    chartType: "line",
    axis: PERCENT_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_new_to_brand_detail_page_views_rate_delta",
    color: metricColors.metric1[0],
    accessor: (d) => d?.new_to_brand_detail_page_views_rate_delta,
    format: "percent",
    chartType: "line",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_new_to_brand_dpvs",
    serverId: "total_new_to_brand_dpvs",
    defaultCompare: "percent",
    color: metricColors.metric2[0],
    accessor: (d) => d?.total_new_to_brand_dpvs,
    prev_accessor: (d) => d?.total_new_to_brand_dpvs_prev,
    percent_accessor: (d) => d?.total_new_to_brand_dpvs_percent ?? null,
    delta_accessor: (d) => (d?.total_new_to_brand_dpvs ?? 0) - (d?.total_new_to_brand_dpvs_prev ?? 0),
    format: "number",
    axis: IMPRESSIONS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_new_to_brand_dpvs_percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.total_new_to_brand_dpvs_percent,
    format: "percent",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_total_new_to_brand_dpv_rate",
    serverId: "total_new_to_brand_dpv_rate",
    defaultCompare: "delta",
    color: metricColors.metric1[0],
    accessor: (d) => (d?.total_new_to_brand_dpv_rate ? d?.total_new_to_brand_dpv_rate : 0),
    prev_accessor: (d) => d?.total_new_to_brand_dpv_rate_prev ?? null,
    percent_accessor: (d) => d?.total_new_to_brand_dpv_rate_percent ?? null,
    delta_accessor: (d) => d?.total_new_to_brand_dpv_rate_delta ?? null,
    format: "percent",
    chartType: "line",
    axis: PERCENT_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_total_new_to_brand_dpv_rate_delta",
    color: metricColors.metric1[0],
    accessor: (d) => d?.total_new_to_brand_dpv_rate_delta,
    format: "percent",
    chartType: "line",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_brand_searches",
    serverId: "brand_searches",
    defaultCompare: "percent",
    color: metricColors.metric2[0],
    accessor: (d) => d?.brand_searches,
    prev_accessor: (d) => d?.brand_searches_prev,
    percent_accessor: (d) => d?.brand_searches_percent ?? null,
    delta_accessor: (d) => (d?.brand_searches ?? 0) - (d?.brand_searches_prev ?? 0),
    format: "number",
    axis: IMPRESSIONS_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_brand_searches_percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.brand_searches_percent,
    format: "percent",
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_brand_searches_rate",
    serverId: "brand_searches_rate",
    defaultCompare: "delta",
    color: metricColors.metric1[0],
    accessor: (d) => (d?.brand_searches_rate ? d?.brand_searches_rate : 0),
    prev_accessor: (d) => d?.brand_searches_rate_prev ?? null,
    percent_accessor: (d) => d?.brand_searches_rate_percent ?? null,
    delta_accessor: (d) => d?.brand_searches_rate_delta ?? null,
    format: "percent",
    chartType: "line",
    axis: PERCENT_AXIS,
    grouping: "merchandising",
  },
  {
    id: "dsp_brand_searches_rate_delta",
    color: metricColors.metric1[0],
    accessor: (d) => d?.brand_searches_rate_delta,
    format: "percent",
    chartType: "line",
    incremental: true,
    axis: PERCENT_AXIS,
  },
  {
    id: "dsp_base_bid",
    color: metricColors.metric1[0],
    accessor: (d) => d?.bid?.baseBid,
    format: "currency",
    chartType: "line",
    grouping: "configuration",
  },
  {
    id: "dsp_ecpm",
    serverId: "ecpm",
    defaultCompare: "percent",
    color: metricColors.acos[0],
    accessor: (d) => d?.ecpm,
    prev_accessor: (d) => d?.ecpm_prev,
    percent_accessor: (d) => d?.ecpm_percent ?? null,
    delta_accessor: (d) => d?.ecpm_delta ?? (d?.ecpm ?? 0) - (d?.ecpm_prev ?? 0),
    format: "currency",
    decimalPlaces: 2,
    axis: PERCENT_AXIS,
    lower: true,
    compareHighlight: "negativeIsGood",
  },
  {
    id: "dsp_ecpm_percent",
    color: metricColors.acos[0],
    accessor: (d) => d?.ecpm_percent,
    format: "percent",
    incremental: true,
    axis: PERCENT_AXIS,
    lower: true,
    compareHighlight: "negativeIsGood",
  },
  {
    id: "dsp_ecpm_delta",
    color: metricColors.acos[0],
    accessor: (d) => d?.ecpm_delta,
    format: "currency",
    incremental: true,
    axis: PERCENT_AXIS,
    lower: true,
  },
  {
    id: "dsp_viewable_impressions",
    defaultCompare: "percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.viewable_impressions ?? 0,
    prev_accessor: (d) => d?.viewable_impressions_prev ?? 0,
    percent_accessor: (d) => d?.viewable_impressions_percent ?? null,
    delta_accessor: (d) => (d?.viewable_impressions ?? 0) - (d?.viewable_impressions_prev ?? 0),
    chartType: "column",
    axis: IMPRESSIONS_AXIS,
    format: "number",
  },
  {
    id: "dsp_viewable_impressions_percent",
    color: metricColors.metric2[1],
    accessor: (d) => d?.viewable_impressions_percent,
    axis: PERCENT_AXIS,
    format: "percent",
  },
  {
    id: "dsp_viewability",
    defaultCompare: "delta",
    color: metricColors.metric2[1],
    accessor: (d) => d?.viewability,
    prev_accessor: (d) => d?.viewability_prev,
    percent_accessor: (d) => {
      const prev = d?.viewability_prev ?? 0;
      if (!prev) return null;
      const current = d?.viewability ?? 0;
      return (current - prev) / prev;
    },
    delta_accessor: (d) => d?.viewability_delta ?? (d?.viewability ?? 0) - (d?.viewability_prev ?? 0),
    axis: PERCENT_AXIS,
    format: "percent",
  },
  {
    id: "dsp_viewability_delta",
    color: metricColors.metric2[1],
    accessor: (d) => d?.viewability_delta,
    axis: PERCENT_AXIS,
    format: "percent",
  },
  {
    id: "dsp_avg_base_bid",
    color: metricColors.metric1[0],
    accessor: (d) => d?.base_bid ?? null,
    axis: BID_AXIS,
    format: "currency",
  },
  {
    id: "dsp_avg_base_bid_percent",
    color: metricColors.metric1[0],
    accessor: (d) => d?.base_bid_percent ?? null,
    axis: PERCENT_AXIS,
    format: "percent",
  },
];
